<template>
	<div class="tile" :class="{ vacant: vacant }">
		<TileOffset :flipY="flipY" v-if="!vacant">
			<component
				:is="catComponentType"
				v-if="!vacant"
				ref="cat"
				:breed="breed"
				:initialState="initialCatState"
				:walkDistance="columnsFromEdge"
				@remove="removeCat"
				@died="block"
			/>
		</TileOffset>
	</div>
</template>

<script>
import TileOffset from '@/components/board/TileOffset';
import Cat from '@/components/cat/Cat';
import TutorialCat from '@/components/tutorial/TutorialCat';
import random from '@/mixins/random';
import { mapGetters } from 'vuex';

export default {
	name: 'Tile',
	components: {
		TileOffset,
		Cat,
		TutorialCat,
	},
	mixins: [random],
	props: {
		catComponentType: {
			default: "Cat",
		},
		columnNumber: 0,
		totalColumns: 0,
	},
	data() {
		return {
			vacant: true,
			blocked: false,
			breed: {},
			initialCatState: false,
		};
	},
	computed: {
		...mapGetters(["breedByName"]),
		isClosestToRightSide() {
			return this.columnNumber > (this.totalColumns / 2);
		},
		columnsFromEdge() {
			let column = this.columnNumber;

			if (this.isClosestToRightSide) {
				column = (this.totalColumns - this.columnNumber) + 1;
			}

			return column;
		},
		flipY() {
			return this.initialCatState === "walking" ? this.isClosestToRightSide : this.randomBoolean();
		},
	},
	methods: {
		insertCat(breed, state) {
			this.vacant = false;
			this.breed = this.breedByName(breed);
			this.initialCatState = state;

			if (this.initialCatState === "death") {
				this.blocked = true;
			}
		},
		removeCat() {
			this.vacant = true;
		},
		block() {
			this.blocked = true;
		},
	},
	created() {
		this.$store.commit("registerTile", { tile: this });
	},
};
</script>

<style lang="scss" scoped>
	.tile {
		flex-shrink: 0;
		position: relative;
		z-index: 1;
		pointer-events: none;
		touch-action: manipulation;

		&.vacant {
			z-index: 0;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/board/Tile.vue